import React, {useContext} from 'react';
import {ScrollableTabsButtonAuto, TabPanel} from '../../../component/tab-panel';
import {HostStateContext} from "../index";


export default function Site() {
    const { auth } = useContext(HostStateContext);
    const access = auth.access['Site'];

    return (
        <div className="build_contents">
            <div className="nv_contents build_contents">
                <div className="build_container">
                    <ScrollableTabsButtonAuto
                        labels={access.labels}
                    >
                        {
                            access.components.map(row => row)
                        }
                    </ScrollableTabsButtonAuto>
                </div>
            </div>
        </div>
    )
}